import * as S from '@effect/schema/Schema';
export var ReferPageBlockConfig = S.struct({
  typename: S.literal('ReferPageBlock'),
  id: S.string,
  hash: S.string,
  hideTwitter: S.nullable(S["boolean"]),
  hideLinkedin: S.nullable(S["boolean"]),
  hideFacebook: S.nullable(S["boolean"]),
  askForSubmitter: S["boolean"],
  shareEnabled: S["boolean"],
  referralDashboardEnabled: S["boolean"]
});